/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibleDirectoryContactUser
 */
export interface EligibleDirectoryContactUser {
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EligibleDirectoryContactUser
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the EligibleDirectoryContactUser interface.
 */
export function instanceOfEligibleDirectoryContactUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function EligibleDirectoryContactUserFromJSON(json: any): EligibleDirectoryContactUser {
    return EligibleDirectoryContactUserFromJSONTyped(json, false);
}

export function EligibleDirectoryContactUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibleDirectoryContactUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function EligibleDirectoryContactUserToJSON(value?: EligibleDirectoryContactUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'email': value.email,
        'phone': value.phone,
    };
}

